import React, { useContext } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import ConfigContext from '../../contexts/ConfigContext';

import 'slick-carousel/slick/slick.css';
import styles from './FeaturedCuisines.module.postcss';
import CDN_BASE from '../../utils/cdn';
import ErrorBoundary from '../shared/ErrorBoundary';

const defaultSettings = {
  slidesToShow: 5,
  slidesToScroll: 2,
  infinite: false,
  lazyLoad: 'anticipated',
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 732,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const getCuisineList = (citySlug) => [
  {
    name: 'Pizza',
    link: '/food-truck-catering/pizza-catering',
    image: `${CDN_BASE}/photos/${citySlug}-pizza-food-truck-catering-400w.webp`,
  },
  {
    name: 'BBQ',
    link: '/food-truck-catering/bbq-catering',
    image: `${CDN_BASE}/photos/${citySlug}-bbq-food-truck-catering-400w.webp`,
  },
  {
    name: 'Taco',
    link: '/food-truck-catering/taco-catering',
    image: `${CDN_BASE}/photos/${citySlug}-taco-food-truck-catering-400w.webp`,
  },
  {
    name: 'Asian',
    link: '/food-truck-catering/asian-catering',
    image: `${CDN_BASE}/photos/${citySlug}-asian-food-truck-catering-400w.webp`,
  },
  {
    name: 'Burger',
    link: '/food-truck-catering/burger-catering',
    image: `${CDN_BASE}/photos/${citySlug}-burger-food-truck-catering-400w.webp`,
  },
  {
    name: 'Dessert',
    link: '/food-truck-catering/dessert-catering',
    image: `${CDN_BASE}/photos/${citySlug}-dessert-food-truck-catering-400w.webp`,
  },
  {
    name: 'Breakfast',
    link: '/food-truck-catering/breakfast-catering',
    image: `${CDN_BASE}/photos/${citySlug}-food-truck-catering-400w.webp`,
  },
  {
    name: 'Wedding',
    link: '/food-truck-catering/wedding-catering',
    image: `${CDN_BASE}/photos/${citySlug}-food-truck-catering-buffet-400w.webp`,
  },
  {
    name: 'Corporate',
    link: '/food-truck-catering/corporate-catering',
    image: `${CDN_BASE}/photos/${citySlug}-food-truck-catering-event-400w.webp`,
  },
  {
    name: 'Birthday',
    link: '/food-truck-catering/birthday-parties',
    image: `${CDN_BASE}/photos/${citySlug}-community-food-truck-event-400w.webp`,
  },
];

function CuisineTease({ name, link, image }) {
  const { vehicle_type } = useContext(ConfigContext);

  return (
    <div className={styles.CuisineTease}>
      <Link className="u-block" to={link}>

        { image &&
          <img
            className={styles.CuisineTease_image}
            src={image}
            alt={name}
            loading='lazy'
          />
        }

        <div className={styles.CuisineTease_info}>
          <div className='u-strong'>{name} food {vehicle_type.toLowerCase()} catering</div>
        </div>

      </Link>
    </div>
  );
}

function FeaturedCuisines() {
  const { vehicle_type, city_name } = useContext(ConfigContext);
  const citySlug = city_name.toLowerCase();
  const cuisineList = getCuisineList(citySlug);

  const slides = cuisineList.map((cuisine) => (
    <div key={'cuisine-' + cuisine.name}>
      <CuisineTease name={cuisine.name} link={cuisine.link} image={cuisine.image} />
    </div>
  ));

  return (
    <div className={styles.FeaturedCuisines}>
      <h2>Food {vehicle_type.toLowerCase()} catering by cuisine and event</h2>
      <Slider {...defaultSettings}>
        {slides}
      </Slider>
    </div>
  );
}

// react-slick / third-party render paths can throw; a crash drops this carousel and keeps the rest of the page.
// Wrapped here rather than at every call site.
function FeaturedCuisinesBoundary(props) {
  return (
    <ErrorBoundary name='FeaturedCuisines'>
      <FeaturedCuisines {...props} />
    </ErrorBoundary>
  );
}

export default FeaturedCuisinesBoundary;
